function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

class UploadClientError extends Error {
  constructor(message, code, request, response, headers) {
    super();
    this.name = 'UploadClientError';
    this.message = message;
    this.code = code;
    this.request = request;
    this.response = response;
    this.headers = headers;
    Object.setPrototypeOf(this, UploadClientError.prototype);
  }

}

const cancelError = function () {
  let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Request canceled';
  const error = new UploadClientError(message);
  error.isCancel = true;
  return error;
};

const onCancel = (signal, callback) => {
  if (signal) {
    if (signal.aborted) {
      Promise.resolve().then(callback);
    } else {
      signal.addEventListener('abort', () => callback(), {
        once: true
      });
    }
  }
};

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

const SEPARATOR = /\W|_/g;

function camelizeString(text) {
  return text.split(SEPARATOR).map((word, index) => word.charAt(0)[index > 0 ? 'toUpperCase' : 'toLowerCase']() + word.slice(1)).join('');
}

function camelizeArrayItems(array) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    ignoreKeys: []
  },
      ignoreKeys = _ref.ignoreKeys;

  if (!Array.isArray(array)) {
    return array;
  }

  return array.map(item => camelizeKeys(item, {
    ignoreKeys
  }));
}

function camelizeKeys(source) {
  let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    ignoreKeys: []
  },
      ignoreKeys = _ref2.ignoreKeys;

  if (Array.isArray(source)) {
    return camelizeArrayItems(source, {
      ignoreKeys
    });
  }

  if (!isObject(source)) {
    return source;
  }

  const result = {};

  for (const key of Object.keys(source)) {
    let value = source[key];

    if (ignoreKeys.includes(key)) {
      result[key] = value;
      continue;
    }

    if (isObject(value)) {
      value = camelizeKeys(value, {
        ignoreKeys
      });
    } else if (Array.isArray(value)) {
      value = camelizeArrayItems(value, {
        ignoreKeys
      });
    }

    result[camelizeString(key)] = value;
  }

  return result;
}
/**
 * setTimeout as Promise.
 *
 * @param {number} ms Timeout in milliseconds.
 */


const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

function getUserAgent$1(_ref3) {
  let libraryName = _ref3.libraryName,
      libraryVersion = _ref3.libraryVersion,
      userAgent = _ref3.userAgent,
      _ref3$publicKey = _ref3.publicKey,
      publicKey = _ref3$publicKey === void 0 ? '' : _ref3$publicKey,
      _ref3$integration = _ref3.integration,
      integration = _ref3$integration === void 0 ? '' : _ref3$integration;
  const languageName = 'JavaScript';

  if (typeof userAgent === 'string') {
    return userAgent;
  }

  if (typeof userAgent === 'function') {
    return userAgent({
      publicKey,
      libraryName,
      libraryVersion,
      languageName,
      integration
    });
  }

  const mainInfo = [libraryName, libraryVersion, publicKey].filter(Boolean).join('/');
  const additionInfo = [languageName, integration].filter(Boolean).join('; ');
  return "".concat(mainInfo, " (").concat(additionInfo, ")");
}

const defaultOptions = {
  factor: 2,
  time: 100
};

function retrier(fn) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  let attempts = 0;

  function runAttempt(fn) {
    const defaultDelayTime = Math.round(options.time * options.factor ** attempts);

    const retry = ms => delay(ms !== null && ms !== void 0 ? ms : defaultDelayTime).then(() => {
      attempts += 1;
      return runAttempt(fn);
    });

    return fn({
      attempt: attempts,
      retry
    });
  }

  return runAttempt(fn);
}

class UploadcareNetworkError extends Error {
  constructor(progressEvent) {
    super();
    this.name = 'UploadcareNetworkError';
    this.message = 'Network error';
    Object.setPrototypeOf(this, UploadcareNetworkError.prototype);
    this.originalProgressEvent = progressEvent;
  }

}

const request = _ref4 => {
  let method = _ref4.method,
      url = _ref4.url,
      data = _ref4.data,
      _ref4$headers = _ref4.headers,
      headers = _ref4$headers === void 0 ? {} : _ref4$headers,
      signal = _ref4.signal,
      onProgress = _ref4.onProgress;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const requestMethod = (method === null || method === void 0 ? void 0 : method.toUpperCase()) || 'GET';
    let aborted = false;
    /**
     * Force synchronous flag to be off
     * Some chrome versions gets `InvalidAccessError` error when we set `responseType`
     * See https://xhr.spec.whatwg.org/#synchronous-flag
     * and https://bugs.chromium.org/p/chromium/issues/detail?id=1346628
     */

    xhr.open(requestMethod, url, true);

    if (headers) {
      Object.entries(headers).forEach(entry => {
        const _entry = _slicedToArray(entry, 2),
              key = _entry[0],
              value = _entry[1];

        typeof value !== 'undefined' && !Array.isArray(value) && xhr.setRequestHeader(key, value);
      });
    }

    xhr.responseType = 'text';
    onCancel(signal, () => {
      aborted = true;
      xhr.abort();
      reject(cancelError());
    });

    xhr.onload = () => {
      if (xhr.status != 200) {
        // analyze HTTP status of the response
        reject(new Error("Error ".concat(xhr.status, ": ").concat(xhr.statusText))); // e.g. 404: Not Found
      } else {
        const request = {
          method: requestMethod,
          url,
          data,
          headers: headers || undefined,
          signal,
          onProgress
        }; // Convert the header string into an array
        // of individual headers

        const headersArray = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/); // Create a map of header names to values

        const responseHeaders = {};
        headersArray.forEach(function (line) {
          const parts = line.split(': ');
          const header = parts.shift();
          const value = parts.join(': ');

          if (header && typeof header !== 'undefined') {
            responseHeaders[header] = value;
          }
        });
        const responseData = xhr.response;
        const responseStatus = xhr.status;
        resolve({
          request,
          data: responseData,
          headers: responseHeaders,
          status: responseStatus
        });
      }
    };

    xhr.onerror = progressEvent => {
      if (aborted) return; // only triggers if the request couldn't be made at all

      reject(new UploadcareNetworkError(progressEvent));
    };

    if (onProgress && typeof onProgress === 'function') {
      xhr.upload.onprogress = event => {
        if (event.lengthComputable) {
          onProgress({
            isComputable: true,
            value: event.loaded / event.total
          });
        } else {
          onProgress({
            isComputable: false
          });
        }
      };
    }

    if (data) {
      xhr.send(data);
    } else {
      xhr.send();
    }
  });
};

function identity(obj) {
  return obj;
}

const getFileOptions = _ref5 => {
  let name = _ref5.name;
  return name ? [name] : [];
};

const transformFile = identity;

var getFormData = () => new FormData();
/**
 * FileData type guard.
 */


const isFileData = data => {
  return data !== undefined && (typeof Blob !== 'undefined' && data instanceof Blob || typeof File !== 'undefined' && data instanceof File || typeof Buffer !== 'undefined' && data instanceof Buffer);
};
/**
 * Uuid type guard.
 */


const isUuid = data => {
  const UUID_REGEX = '[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}';
  const regExp = new RegExp(UUID_REGEX);
  return !isFileData(data) && regExp.test(data);
};
/**
 * Url type guard.
 *
 * @param {NodeFile | BrowserFile | Url | Uuid} data
 */


const isUrl = data => {
  const URL_REGEX = '^(?:\\w+:)?\\/\\/([^\\s\\.]+\\.\\S{2}|localhost[\\:?\\d]*)\\S*$';
  const regExp = new RegExp(URL_REGEX);
  return !isFileData(data) && regExp.test(data);
};

const isSimpleValue = value => {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'undefined';
};

const isObjectValue = value => {
  return !!value && typeof value === 'object' && !Array.isArray(value);
};

const isFileValue = value => !!value && typeof value === 'object' && 'data' in value && isFileData(value.data);

function collectParams(params, inputKey, inputValue) {
  if (isFileValue(inputValue)) {
    const name = inputValue.name,
          contentType = inputValue.contentType;
    const file = transformFile(inputValue.data); // lgtm [js/superfluous-trailing-arguments]

    const options = getFileOptions({
      name,
      contentType
    });
    params.push([inputKey, file, ...options]);
  } else if (isObjectValue(inputValue)) {
    for (const _ref6 of Object.entries(inputValue)) {
      var _ref7 = _slicedToArray(_ref6, 2);

      const key = _ref7[0];
      const value = _ref7[1];

      if (typeof value !== 'undefined') {
        params.push(["".concat(inputKey, "[").concat(key, "]"), String(value)]);
      }
    }
  } else if (isSimpleValue(inputValue) && inputValue) {
    params.push([inputKey, inputValue.toString()]);
  }
}

function getFormDataParams(options) {
  const params = [];

  for (const _ref8 of Object.entries(options)) {
    var _ref9 = _slicedToArray(_ref8, 2);

    const key = _ref9[0];
    const value = _ref9[1];
    collectParams(params, key, value);
  }

  return params;
}

function buildFormData(options) {
  const formData = getFormData();
  const paramsList = getFormDataParams(options);

  for (const params of paramsList) {
    const _params = _toArray(params),
          key = _params[0],
          value = _params[1],
          options = _params.slice(2); // node form-data has another signature for append


    formData.append(key, value, ...options);
  }

  return formData;
}

const buildSearchParams = query => {
  const searchParams = new URLSearchParams();

  for (const _ref10 of Object.entries(query)) {
    var _ref11 = _slicedToArray(_ref10, 2);

    const key = _ref11[0];
    const value = _ref11[1];

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.entries(value).filter(entry => {
        var _entry$;

        return (_entry$ = entry[1]) !== null && _entry$ !== void 0 ? _entry$ : false;
      }).forEach(entry => searchParams.set("".concat(key, "[").concat(entry[0], "]"), String(entry[1])));
    } else if (Array.isArray(value)) {
      value.forEach(val => {
        searchParams.append("".concat(key, "[]"), val);
      });
    } else if (typeof value === 'string' && value) {
      searchParams.set(key, value);
    } else if (typeof value === 'number') {
      searchParams.set(key, value.toString());
    }
  }

  return searchParams.toString();
};

const getUrl = (base, path, query) => {
  const url = new URL(base);
  url.pathname = (url.pathname + path).replace('//', '/');

  if (query) {
    url.search = buildSearchParams(query);
  }

  return url.toString();
};
/*
  Settings for future support:
  parallelDirectUploads: 10,
 */


const defaultSettings = {
  baseCDN: 'https://ucarecdn.com',
  baseURL: 'https://upload.uploadcare.com',
  maxContentLength: 50 * 1024 * 1024,
  retryThrottledRequestMaxTimes: 1,
  retryNetworkErrorMaxTimes: 3,
  multipartMinFileSize: 25 * 1024 * 1024,
  multipartChunkSize: 5 * 1024 * 1024,
  multipartMinLastPartSize: 1024 * 1024,
  maxConcurrentRequests: 4,
  pollingTimeoutMilliseconds: 10000,
  pusherKey: '79ae88bd931ea68464d9'
};
const defaultContentType = 'application/octet-stream';
const defaultFilename = 'original';
var version = '5.1.0';
const LIBRARY_NAME = 'UploadcareUploadClient';
const LIBRARY_VERSION = version;

function getUserAgent(options) {
  return getUserAgent$1(_objectSpread({
    libraryName: LIBRARY_NAME,
    libraryVersion: LIBRARY_VERSION
  }, options));
}

const REQUEST_WAS_THROTTLED_CODE = 'RequestThrottledError';
const DEFAULT_THROTTLED_TIMEOUT = 15000;
const DEFAULT_NETWORK_ERROR_TIMEOUT = 1000;

function getTimeoutFromThrottledRequest(error) {
  const _ref12 = error || {},
        headers = _ref12.headers;

  return headers && Number.parseInt(headers['x-throttle-wait-seconds']) * 1000 || DEFAULT_THROTTLED_TIMEOUT;
}

function retryIfFailed(fn, options) {
  const retryThrottledRequestMaxTimes = options.retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes = options.retryNetworkErrorMaxTimes;
  return retrier(_ref13 => {
    let attempt = _ref13.attempt,
        retry = _ref13.retry;
    return fn().catch(error => {
      if ('response' in error && (error === null || error === void 0 ? void 0 : error.code) === REQUEST_WAS_THROTTLED_CODE && attempt < retryThrottledRequestMaxTimes) {
        return retry(getTimeoutFromThrottledRequest(error));
      }

      if (error instanceof UploadcareNetworkError && attempt < retryNetworkErrorMaxTimes) {
        return retry((attempt + 1) * DEFAULT_NETWORK_ERROR_TIMEOUT);
      }

      throw error;
    });
  });
}

function getStoreValue(store) {
  return typeof store === 'undefined' ? 'auto' : store ? '1' : '0';
}
/**
 * Performs file uploading request to Uploadcare Upload API.
 * Can be canceled and has progress.
 */


function base(file, _ref14) {
  let publicKey = _ref14.publicKey,
      fileName = _ref14.fileName,
      contentType = _ref14.contentType,
      _ref14$baseURL = _ref14.baseURL,
      baseURL = _ref14$baseURL === void 0 ? defaultSettings.baseURL : _ref14$baseURL,
      secureSignature = _ref14.secureSignature,
      secureExpire = _ref14.secureExpire,
      store = _ref14.store,
      signal = _ref14.signal,
      onProgress = _ref14.onProgress,
      _ref14$source = _ref14.source,
      source = _ref14$source === void 0 ? 'local' : _ref14$source,
      integration = _ref14.integration,
      userAgent = _ref14.userAgent,
      _ref14$retryThrottled = _ref14.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref14$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref14$retryThrottled,
      _ref14$retryNetworkEr = _ref14.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref14$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref14$retryNetworkEr,
      metadata = _ref14.metadata;
  return retryIfFailed(() => {
    var _ref15;

    return request({
      method: 'POST',
      url: getUrl(baseURL, '/base/', {
        jsonerrors: 1
      }),
      headers: {
        'X-UC-User-Agent': getUserAgent({
          publicKey,
          integration,
          userAgent
        })
      },
      data: buildFormData({
        file: {
          data: file,
          name: (_ref15 = fileName !== null && fileName !== void 0 ? fileName : file.name) !== null && _ref15 !== void 0 ? _ref15 : defaultFilename,
          contentType
        },
        UPLOADCARE_PUB_KEY: publicKey,
        UPLOADCARE_STORE: getStoreValue(store),
        signature: secureSignature,
        expire: secureExpire,
        source: source,
        metadata
      }),
      signal,
      onProgress
    }).then(_ref16 => {
      let data = _ref16.data,
          headers = _ref16.headers,
          request = _ref16.request;
      const response = camelizeKeys(JSON.parse(data));

      if ('error' in response) {
        throw new UploadClientError(response.error.content, response.error.errorCode, request, response, headers);
      } else {
        return response;
      }
    });
  }, {
    retryNetworkErrorMaxTimes,
    retryThrottledRequestMaxTimes
  });
}

var TypeEnum;

(function (TypeEnum) {
  TypeEnum["Token"] = "token";
  TypeEnum["FileInfo"] = "file_info";
})(TypeEnum || (TypeEnum = {}));
/**
 * Uploading files from URL.
 */


function fromUrl(sourceUrl, _ref17) {
  let publicKey = _ref17.publicKey,
      _ref17$baseURL = _ref17.baseURL,
      baseURL = _ref17$baseURL === void 0 ? defaultSettings.baseURL : _ref17$baseURL,
      store = _ref17.store,
      fileName = _ref17.fileName,
      checkForUrlDuplicates = _ref17.checkForUrlDuplicates,
      saveUrlForRecurrentUploads = _ref17.saveUrlForRecurrentUploads,
      secureSignature = _ref17.secureSignature,
      secureExpire = _ref17.secureExpire,
      _ref17$source = _ref17.source,
      source = _ref17$source === void 0 ? 'url' : _ref17$source,
      signal = _ref17.signal,
      integration = _ref17.integration,
      userAgent = _ref17.userAgent,
      _ref17$retryThrottled = _ref17.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref17$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref17$retryThrottled,
      _ref17$retryNetworkEr = _ref17.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref17$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref17$retryNetworkEr,
      metadata = _ref17.metadata;
  return retryIfFailed(() => request({
    method: 'POST',
    headers: {
      'X-UC-User-Agent': getUserAgent({
        publicKey,
        integration,
        userAgent
      })
    },
    url: getUrl(baseURL, '/from_url/', {
      jsonerrors: 1,
      pub_key: publicKey,
      source_url: sourceUrl,
      store: getStoreValue(store),
      filename: fileName,
      check_URL_duplicates: checkForUrlDuplicates ? 1 : undefined,
      save_URL_duplicates: saveUrlForRecurrentUploads ? 1 : undefined,
      signature: secureSignature,
      expire: secureExpire,
      source: source,
      metadata
    }),
    signal
  }).then(_ref18 => {
    let data = _ref18.data,
        headers = _ref18.headers,
        request = _ref18.request;
    const response = camelizeKeys(JSON.parse(data));

    if ('error' in response) {
      throw new UploadClientError(response.error.content, response.error.errorCode, request, response, headers);
    } else {
      return response;
    }
  }), {
    retryNetworkErrorMaxTimes,
    retryThrottledRequestMaxTimes
  });
}

var Status;

(function (Status) {
  Status["Unknown"] = "unknown";
  Status["Waiting"] = "waiting";
  Status["Progress"] = "progress";
  Status["Error"] = "error";
  Status["Success"] = "success";
})(Status || (Status = {}));

const isErrorResponse = response => {
  return 'status' in response && response.status === Status.Error;
};
/**
 * Checking upload status and working with file tokens.
 */


function fromUrlStatus(token) {
  let _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      publicKey = _ref19.publicKey,
      _ref19$baseURL = _ref19.baseURL,
      baseURL = _ref19$baseURL === void 0 ? defaultSettings.baseURL : _ref19$baseURL,
      signal = _ref19.signal,
      integration = _ref19.integration,
      userAgent = _ref19.userAgent,
      _ref19$retryThrottled = _ref19.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref19$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref19$retryThrottled,
      _ref19$retryNetworkEr = _ref19.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref19$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref19$retryNetworkEr;

  return retryIfFailed(() => request({
    method: 'GET',
    headers: publicKey ? {
      'X-UC-User-Agent': getUserAgent({
        publicKey,
        integration,
        userAgent
      })
    } : undefined,
    url: getUrl(baseURL, '/from_url/status/', {
      jsonerrors: 1,
      token
    }),
    signal
  }).then(_ref20 => {
    let data = _ref20.data,
        headers = _ref20.headers,
        request = _ref20.request;
    const response = camelizeKeys(JSON.parse(data));

    if ('error' in response && !isErrorResponse(response)) {
      throw new UploadClientError(response.error.content, undefined, request, response, headers);
    } else {
      return response;
    }
  }), {
    retryNetworkErrorMaxTimes,
    retryThrottledRequestMaxTimes
  });
}
/**
 * Create files group.
 */


function group(uuids, _ref21) {
  let publicKey = _ref21.publicKey,
      _ref21$baseURL = _ref21.baseURL,
      baseURL = _ref21$baseURL === void 0 ? defaultSettings.baseURL : _ref21$baseURL,
      jsonpCallback = _ref21.jsonpCallback,
      secureSignature = _ref21.secureSignature,
      secureExpire = _ref21.secureExpire,
      signal = _ref21.signal,
      source = _ref21.source,
      integration = _ref21.integration,
      userAgent = _ref21.userAgent,
      _ref21$retryThrottled = _ref21.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref21$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref21$retryThrottled,
      _ref21$retryNetworkEr = _ref21.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref21$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref21$retryNetworkEr;
  return retryIfFailed(() => request({
    method: 'POST',
    headers: {
      'X-UC-User-Agent': getUserAgent({
        publicKey,
        integration,
        userAgent
      })
    },
    url: getUrl(baseURL, '/group/', {
      jsonerrors: 1,
      pub_key: publicKey,
      files: uuids,
      callback: jsonpCallback,
      signature: secureSignature,
      expire: secureExpire,
      source
    }),
    signal
  }).then(_ref22 => {
    let data = _ref22.data,
        headers = _ref22.headers,
        request = _ref22.request;
    const response = camelizeKeys(JSON.parse(data));

    if ('error' in response) {
      throw new UploadClientError(response.error.content, response.error.errorCode, request, response, headers);
    } else {
      return response;
    }
  }), {
    retryNetworkErrorMaxTimes,
    retryThrottledRequestMaxTimes
  });
}
/**
 * Get info about group.
 */


function groupInfo(id, _ref23) {
  let publicKey = _ref23.publicKey,
      _ref23$baseURL = _ref23.baseURL,
      baseURL = _ref23$baseURL === void 0 ? defaultSettings.baseURL : _ref23$baseURL,
      signal = _ref23.signal,
      source = _ref23.source,
      integration = _ref23.integration,
      userAgent = _ref23.userAgent,
      _ref23$retryThrottled = _ref23.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref23$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref23$retryThrottled,
      _ref23$retryNetworkEr = _ref23.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref23$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref23$retryNetworkEr;
  return retryIfFailed(() => request({
    method: 'GET',
    headers: {
      'X-UC-User-Agent': getUserAgent({
        publicKey,
        integration,
        userAgent
      })
    },
    url: getUrl(baseURL, '/group/info/', {
      jsonerrors: 1,
      pub_key: publicKey,
      group_id: id,
      source
    }),
    signal
  }).then(_ref24 => {
    let data = _ref24.data,
        headers = _ref24.headers,
        request = _ref24.request;
    const response = camelizeKeys(JSON.parse(data));

    if ('error' in response) {
      throw new UploadClientError(response.error.content, response.error.errorCode, request, response, headers);
    } else {
      return response;
    }
  }), {
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes
  });
}
/**
 * Returns a JSON dictionary holding file info.
 */


function info(uuid, _ref25) {
  let publicKey = _ref25.publicKey,
      _ref25$baseURL = _ref25.baseURL,
      baseURL = _ref25$baseURL === void 0 ? defaultSettings.baseURL : _ref25$baseURL,
      signal = _ref25.signal,
      source = _ref25.source,
      integration = _ref25.integration,
      userAgent = _ref25.userAgent,
      _ref25$retryThrottled = _ref25.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref25$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref25$retryThrottled,
      _ref25$retryNetworkEr = _ref25.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref25$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref25$retryNetworkEr;
  return retryIfFailed(() => request({
    method: 'GET',
    headers: {
      'X-UC-User-Agent': getUserAgent({
        publicKey,
        integration,
        userAgent
      })
    },
    url: getUrl(baseURL, '/info/', {
      jsonerrors: 1,
      pub_key: publicKey,
      file_id: uuid,
      source
    }),
    signal
  }).then(_ref26 => {
    let data = _ref26.data,
        headers = _ref26.headers,
        request = _ref26.request;
    const response = camelizeKeys(JSON.parse(data));

    if ('error' in response) {
      throw new UploadClientError(response.error.content, response.error.errorCode, request, response, headers);
    } else {
      return response;
    }
  }), {
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes
  });
}
/**
 * Start multipart uploading.
 */


function multipartStart(size, _ref27) {
  let publicKey = _ref27.publicKey,
      contentType = _ref27.contentType,
      fileName = _ref27.fileName,
      _ref27$multipartChunk = _ref27.multipartChunkSize,
      multipartChunkSize = _ref27$multipartChunk === void 0 ? defaultSettings.multipartChunkSize : _ref27$multipartChunk,
      _ref27$baseURL = _ref27.baseURL,
      baseURL = _ref27$baseURL === void 0 ? '' : _ref27$baseURL,
      secureSignature = _ref27.secureSignature,
      secureExpire = _ref27.secureExpire,
      store = _ref27.store,
      signal = _ref27.signal,
      _ref27$source = _ref27.source,
      source = _ref27$source === void 0 ? 'local' : _ref27$source,
      integration = _ref27.integration,
      userAgent = _ref27.userAgent,
      _ref27$retryThrottled = _ref27.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref27$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref27$retryThrottled,
      _ref27$retryNetworkEr = _ref27.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref27$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref27$retryNetworkEr,
      metadata = _ref27.metadata;
  return retryIfFailed(() => request({
    method: 'POST',
    url: getUrl(baseURL, '/multipart/start/', {
      jsonerrors: 1
    }),
    headers: {
      'X-UC-User-Agent': getUserAgent({
        publicKey,
        integration,
        userAgent
      })
    },
    data: buildFormData({
      filename: fileName !== null && fileName !== void 0 ? fileName : defaultFilename,
      size: size,
      content_type: contentType !== null && contentType !== void 0 ? contentType : defaultContentType,
      part_size: multipartChunkSize,
      UPLOADCARE_STORE: getStoreValue(store),
      UPLOADCARE_PUB_KEY: publicKey,
      signature: secureSignature,
      expire: secureExpire,
      source: source,
      metadata
    }),
    signal
  }).then(_ref28 => {
    let data = _ref28.data,
        headers = _ref28.headers,
        request = _ref28.request;
    const response = camelizeKeys(JSON.parse(data));

    if ('error' in response) {
      throw new UploadClientError(response.error.content, response.error.errorCode, request, response, headers);
    } else {
      // convert to array
      response.parts = Object.keys(response.parts).map(key => response.parts[key]);
      return response;
    }
  }), {
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes
  });
}
/**
 * Complete multipart uploading.
 */


function multipartUpload(part, url, _ref29) {
  let signal = _ref29.signal,
      onProgress = _ref29.onProgress,
      _ref29$retryThrottled = _ref29.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref29$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref29$retryThrottled,
      _ref29$retryNetworkEr = _ref29.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref29$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref29$retryNetworkEr;
  return retryIfFailed(() => request({
    method: 'PUT',
    url,
    data: part,
    // Upload request can't be non-computable because we always know exact size
    onProgress: onProgress,
    signal
  }).then(result => {
    // hack for node ¯\_(ツ)_/¯
    if (onProgress) onProgress({
      isComputable: true,
      value: 1
    });
    return result;
  }).then(_ref30 => {
    let status = _ref30.status;
    return {
      code: status
    };
  }), {
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes
  });
}
/**
 * Complete multipart uploading.
 */


function multipartComplete(uuid, _ref31) {
  let publicKey = _ref31.publicKey,
      _ref31$baseURL = _ref31.baseURL,
      baseURL = _ref31$baseURL === void 0 ? defaultSettings.baseURL : _ref31$baseURL,
      _ref31$source = _ref31.source,
      source = _ref31$source === void 0 ? 'local' : _ref31$source,
      signal = _ref31.signal,
      integration = _ref31.integration,
      userAgent = _ref31.userAgent,
      _ref31$retryThrottled = _ref31.retryThrottledRequestMaxTimes,
      retryThrottledRequestMaxTimes = _ref31$retryThrottled === void 0 ? defaultSettings.retryThrottledRequestMaxTimes : _ref31$retryThrottled,
      _ref31$retryNetworkEr = _ref31.retryNetworkErrorMaxTimes,
      retryNetworkErrorMaxTimes = _ref31$retryNetworkEr === void 0 ? defaultSettings.retryNetworkErrorMaxTimes : _ref31$retryNetworkEr;
  return retryIfFailed(() => request({
    method: 'POST',
    url: getUrl(baseURL, '/multipart/complete/', {
      jsonerrors: 1
    }),
    headers: {
      'X-UC-User-Agent': getUserAgent({
        publicKey,
        integration,
        userAgent
      })
    },
    data: buildFormData({
      uuid: uuid,
      UPLOADCARE_PUB_KEY: publicKey,
      source: source
    }),
    signal
  }).then(_ref32 => {
    let data = _ref32.data,
        headers = _ref32.headers,
        request = _ref32.request;
    const response = camelizeKeys(JSON.parse(data));

    if ('error' in response) {
      throw new UploadClientError(response.error.content, response.error.errorCode, request, response, headers);
    } else {
      return response;
    }
  }), {
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes
  });
}

class UploadcareFile {
  constructor(fileInfo, _ref33) {
    let baseCDN = _ref33.baseCDN,
        fileName = _ref33.fileName;
    this.name = null;
    this.size = null;
    this.isStored = null;
    this.isImage = null;
    this.mimeType = null;
    this.cdnUrl = null;
    this.s3Url = null;
    this.originalFilename = null;
    this.imageInfo = null;
    this.videoInfo = null;
    this.contentInfo = null;
    this.metadata = null;
    this.s3Bucket = null;
    const uuid = fileInfo.uuid,
          s3Bucket = fileInfo.s3Bucket;
    const cdnUrl = "".concat(baseCDN, "/").concat(uuid, "/");
    const s3Url = s3Bucket ? "https://".concat(s3Bucket, ".s3.amazonaws.com/").concat(uuid, "/").concat(fileInfo.filename) : null;
    this.uuid = uuid;
    this.name = fileName || fileInfo.filename;
    this.size = fileInfo.size;
    this.isStored = fileInfo.isStored;
    this.isImage = fileInfo.isImage;
    this.mimeType = fileInfo.mimeType;
    this.cdnUrl = cdnUrl;
    this.originalFilename = fileInfo.originalFilename;
    this.imageInfo = fileInfo.imageInfo;
    this.videoInfo = fileInfo.videoInfo;
    this.contentInfo = fileInfo.contentInfo;
    this.metadata = fileInfo.metadata || null;
    this.s3Bucket = s3Bucket || null;
    this.s3Url = s3Url;
  }

}

const DEFAULT_INTERVAL = 500;

const poll = _ref34 => {
  let check = _ref34.check,
      _ref34$interval = _ref34.interval,
      interval = _ref34$interval === void 0 ? DEFAULT_INTERVAL : _ref34$interval,
      signal = _ref34.signal;
  return new Promise((resolve, reject) => {
    let timeoutId;
    onCancel(signal, () => {
      timeoutId && clearTimeout(timeoutId);
      reject(cancelError('Poll cancelled'));
    });

    const tick = () => {
      try {
        Promise.resolve(check(signal)).then(result => {
          if (result) {
            resolve(result);
          } else {
            timeoutId = setTimeout(tick, interval);
          }
        }).catch(error => reject(error));
      } catch (error) {
        reject(error);
      }
    };

    timeoutId = setTimeout(tick, 0);
  });
};

function isReadyPoll(_ref35) {
  let file = _ref35.file,
      publicKey = _ref35.publicKey,
      baseURL = _ref35.baseURL,
      source = _ref35.source,
      integration = _ref35.integration,
      userAgent = _ref35.userAgent,
      retryThrottledRequestMaxTimes = _ref35.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref35.retryNetworkErrorMaxTimes,
      signal = _ref35.signal,
      onProgress = _ref35.onProgress;
  return poll({
    check: signal => info(file, {
      publicKey,
      baseURL,
      signal,
      source,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes
    }).then(response => {
      if (response.isReady) {
        return response;
      }

      onProgress && onProgress({
        isComputable: true,
        value: 1
      });
      return false;
    }),
    signal
  });
}

const uploadDirect = (file, _ref36) => {
  let publicKey = _ref36.publicKey,
      fileName = _ref36.fileName,
      baseURL = _ref36.baseURL,
      secureSignature = _ref36.secureSignature,
      secureExpire = _ref36.secureExpire,
      store = _ref36.store,
      contentType = _ref36.contentType,
      signal = _ref36.signal,
      onProgress = _ref36.onProgress,
      source = _ref36.source,
      integration = _ref36.integration,
      userAgent = _ref36.userAgent,
      retryThrottledRequestMaxTimes = _ref36.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref36.retryNetworkErrorMaxTimes,
      baseCDN = _ref36.baseCDN,
      metadata = _ref36.metadata;
  return base(file, {
    publicKey,
    fileName,
    contentType,
    baseURL,
    secureSignature,
    secureExpire,
    store,
    signal,
    onProgress,
    source,
    integration,
    userAgent,
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes,
    metadata
  }).then(_ref37 => {
    let file = _ref37.file;
    return isReadyPoll({
      file,
      publicKey,
      baseURL,
      source,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes,
      onProgress,
      signal
    });
  }).then(fileInfo => new UploadcareFile(fileInfo, {
    baseCDN
  }));
};

const race = function (fns) {
  let _ref38 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      signal = _ref38.signal;

  let lastError = null;
  let winnerIndex = null;
  const controllers = fns.map(() => new AbortController());

  const createStopRaceCallback = i => () => {
    winnerIndex = i;
    controllers.forEach((controller, index) => index !== i && controller.abort());
  };

  onCancel(signal, () => {
    controllers.forEach(controller => controller.abort());
  });
  return Promise.all(fns.map((fn, i) => {
    const stopRace = createStopRaceCallback(i);
    return Promise.resolve().then(() => fn({
      stopRace,
      signal: controllers[i].signal
    })).then(result => {
      stopRace();
      return result;
    }).catch(error => {
      lastError = error;
      return null;
    });
  })).then(results => {
    if (winnerIndex === null) {
      throw lastError;
    } else {
      return results[winnerIndex];
    }
  });
};

var WebSocket = window.WebSocket;

class Events {
  constructor() {
    this.events = Object.create({});
  }

  emit(event, data) {
    var _this$events$event;

    (_this$events$event = this.events[event]) === null || _this$events$event === void 0 ? void 0 : _this$events$event.forEach(fn => fn(data));
  }

  on(event, callback) {
    this.events[event] = this.events[event] || [];
    this.events[event].push(callback);
  }

  off(event, callback) {
    if (callback) {
      this.events[event] = this.events[event].filter(fn => fn !== callback);
    } else {
      this.events[event] = [];
    }
  }

}

const response = (type, data) => {
  if (type === 'success') {
    return _objectSpread({
      status: Status.Success
    }, data);
  }

  if (type === 'progress') {
    return _objectSpread({
      status: Status.Progress
    }, data);
  }

  return _objectSpread({
    status: Status.Error
  }, data);
};

class Pusher {
  constructor(pusherKey) {
    let disconnectTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30000;
    this.ws = undefined;
    this.queue = [];
    this.isConnected = false;
    this.subscribers = 0;
    this.emmitter = new Events();
    this.disconnectTimeoutId = null;
    this.key = pusherKey;
    this.disconnectTime = disconnectTime;
  }

  connect() {
    this.disconnectTimeoutId && clearTimeout(this.disconnectTimeoutId);

    if (!this.isConnected && !this.ws) {
      const pusherUrl = "wss://ws.pusherapp.com/app/".concat(this.key, "?protocol=5&client=js&version=1.12.2");
      this.ws = new WebSocket(pusherUrl);
      this.ws.addEventListener('error', error => {
        this.emmitter.emit('error', new Error(error.message));
      });
      this.emmitter.on('connected', () => {
        this.isConnected = true;
        this.queue.forEach(message => this.send(message.event, message.data));
        this.queue = [];
      });
      this.ws.addEventListener('message', e => {
        const data = JSON.parse(e.data.toString());

        switch (data.event) {
          case 'pusher:connection_established':
            {
              this.emmitter.emit('connected', undefined);
              break;
            }

          case 'pusher:ping':
            {
              this.send('pusher:pong', {});
              break;
            }

          case 'progress':
          case 'success':
          case 'fail':
            {
              this.emmitter.emit(data.channel, response(data.event, JSON.parse(data.data)));
            }
        }
      });
    }
  }

  disconnect() {
    const actualDisconect = () => {
      var _this$ws;

      (_this$ws = this.ws) === null || _this$ws === void 0 ? void 0 : _this$ws.close();
      this.ws = undefined;
      this.isConnected = false;
    };

    if (this.disconnectTime) {
      this.disconnectTimeoutId = setTimeout(() => {
        actualDisconect();
      }, this.disconnectTime);
    } else {
      actualDisconect();
    }
  }

  send(event, data) {
    var _this$ws2;

    const str = JSON.stringify({
      event,
      data
    });
    (_this$ws2 = this.ws) === null || _this$ws2 === void 0 ? void 0 : _this$ws2.send(str);
  }

  subscribe(token, handler) {
    this.subscribers += 1;
    this.connect();
    const channel = "task-status-".concat(token);
    const message = {
      event: 'pusher:subscribe',
      data: {
        channel
      }
    };
    this.emmitter.on(channel, handler);

    if (this.isConnected) {
      this.send(message.event, message.data);
    } else {
      this.queue.push(message);
    }
  }

  unsubscribe(token) {
    this.subscribers -= 1;
    const channel = "task-status-".concat(token);
    const message = {
      event: 'pusher:unsubscribe',
      data: {
        channel
      }
    };
    this.emmitter.off(channel);

    if (this.isConnected) {
      this.send(message.event, message.data);
    } else {
      this.queue = this.queue.filter(msg => msg.data.channel !== channel);
    }

    if (this.subscribers === 0) {
      this.disconnect();
    }
  }

  onError(callback) {
    this.emmitter.on('error', callback);
    return () => this.emmitter.off('error', callback);
  }

}

let pusher = null;

const getPusher = key => {
  if (!pusher) {
    // no timeout for nodeJS and 30000 ms for browser
    const disconectTimeout = typeof window === 'undefined' ? 0 : 30000;
    pusher = new Pusher(key, disconectTimeout);
  }

  return pusher;
};

const preconnect = key => {
  getPusher(key).connect();
};

function pollStrategy(_ref39) {
  let token = _ref39.token,
      publicKey = _ref39.publicKey,
      baseURL = _ref39.baseURL,
      integration = _ref39.integration,
      userAgent = _ref39.userAgent,
      retryThrottledRequestMaxTimes = _ref39.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref39.retryNetworkErrorMaxTimes,
      onProgress = _ref39.onProgress,
      signal = _ref39.signal;
  return poll({
    check: signal => fromUrlStatus(token, {
      publicKey,
      baseURL,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes,
      signal
    }).then(response => {
      switch (response.status) {
        case Status.Error:
          {
            return new UploadClientError(response.error, response.errorCode);
          }

        case Status.Waiting:
          {
            return false;
          }

        case Status.Unknown:
          {
            return new UploadClientError("Token \"".concat(token, "\" was not found."));
          }

        case Status.Progress:
          {
            if (onProgress) {
              if (response.total === 'unknown') {
                onProgress({
                  isComputable: false
                });
              } else {
                onProgress({
                  isComputable: true,
                  value: response.done / response.total
                });
              }
            }

            return false;
          }

        case Status.Success:
          {
            if (onProgress) onProgress({
              isComputable: true,
              value: response.done / response.total
            });
            return response;
          }

        default:
          {
            throw new Error('Unknown status');
          }
      }
    }),
    signal
  });
}

const pushStrategy = _ref40 => {
  let token = _ref40.token,
      pusherKey = _ref40.pusherKey,
      signal = _ref40.signal,
      onProgress = _ref40.onProgress;
  return new Promise((resolve, reject) => {
    const pusher = getPusher(pusherKey);
    const unsubErrorHandler = pusher.onError(reject);

    const destroy = () => {
      unsubErrorHandler();
      pusher.unsubscribe(token);
    };

    onCancel(signal, () => {
      destroy();
      reject(cancelError('pusher cancelled'));
    });
    pusher.subscribe(token, result => {
      switch (result.status) {
        case Status.Progress:
          {
            if (onProgress) {
              if (result.total === 'unknown') {
                onProgress({
                  isComputable: false
                });
              } else {
                onProgress({
                  isComputable: true,
                  value: result.done / result.total
                });
              }
            }

            break;
          }

        case Status.Success:
          {
            destroy();
            if (onProgress) onProgress({
              isComputable: true,
              value: result.done / result.total
            });
            resolve(result);
            break;
          }

        case Status.Error:
          {
            destroy();
            reject(new UploadClientError(result.msg, result.error_code));
          }
      }
    });
  });
};

const uploadFromUrl = (sourceUrl, _ref41) => {
  let publicKey = _ref41.publicKey,
      fileName = _ref41.fileName,
      baseURL = _ref41.baseURL,
      baseCDN = _ref41.baseCDN,
      checkForUrlDuplicates = _ref41.checkForUrlDuplicates,
      saveUrlForRecurrentUploads = _ref41.saveUrlForRecurrentUploads,
      secureSignature = _ref41.secureSignature,
      secureExpire = _ref41.secureExpire,
      store = _ref41.store,
      signal = _ref41.signal,
      onProgress = _ref41.onProgress,
      source = _ref41.source,
      integration = _ref41.integration,
      userAgent = _ref41.userAgent,
      retryThrottledRequestMaxTimes = _ref41.retryThrottledRequestMaxTimes,
      _ref41$pusherKey = _ref41.pusherKey,
      pusherKey = _ref41$pusherKey === void 0 ? defaultSettings.pusherKey : _ref41$pusherKey,
      metadata = _ref41.metadata;
  return Promise.resolve(preconnect(pusherKey)).then(() => fromUrl(sourceUrl, {
    publicKey,
    fileName,
    baseURL,
    checkForUrlDuplicates,
    saveUrlForRecurrentUploads,
    secureSignature,
    secureExpire,
    store,
    signal,
    source,
    integration,
    userAgent,
    retryThrottledRequestMaxTimes,
    metadata
  })).catch(error => {
    const pusher = getPusher(pusherKey);
    pusher === null || pusher === void 0 ? void 0 : pusher.disconnect();
    return Promise.reject(error);
  }).then(urlResponse => {
    if (urlResponse.type === TypeEnum.FileInfo) {
      return urlResponse;
    } else {
      return race([_ref42 => {
        let signal = _ref42.signal;
        return pollStrategy({
          token: urlResponse.token,
          publicKey,
          baseURL,
          integration,
          userAgent,
          retryThrottledRequestMaxTimes,
          onProgress,
          signal
        });
      }, _ref43 => {
        let signal = _ref43.signal;
        return pushStrategy({
          token: urlResponse.token,
          pusherKey,
          signal,
          onProgress
        });
      }], {
        signal
      });
    }
  }).then(result => {
    if (result instanceof UploadClientError) throw result;
    return result;
  }).then(result => isReadyPoll({
    file: result.uuid,
    publicKey,
    baseURL,
    integration,
    userAgent,
    retryThrottledRequestMaxTimes,
    onProgress,
    signal
  })).then(fileInfo => new UploadcareFile(fileInfo, {
    baseCDN
  }));
};

const uploadFromUploaded = (uuid, _ref44) => {
  let publicKey = _ref44.publicKey,
      fileName = _ref44.fileName,
      baseURL = _ref44.baseURL,
      signal = _ref44.signal,
      onProgress = _ref44.onProgress,
      source = _ref44.source,
      integration = _ref44.integration,
      userAgent = _ref44.userAgent,
      retryThrottledRequestMaxTimes = _ref44.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref44.retryNetworkErrorMaxTimes,
      baseCDN = _ref44.baseCDN;
  return info(uuid, {
    publicKey,
    baseURL,
    signal,
    source,
    integration,
    userAgent,
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes
  }).then(fileInfo => new UploadcareFile(fileInfo, {
    baseCDN,
    fileName
  })).then(result => {
    // hack for node ¯\_(ツ)_/¯
    if (onProgress) onProgress({
      isComputable: true,
      value: 1
    });
    return result;
  });
};
/**
 * Get file size.
 */


const getFileSize = file => {
  return file.length || file.size;
};
/**
 * Check if FileData is multipart data.
 */


const isMultipart = function (fileSize) {
  let multipartMinFileSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSettings.multipartMinFileSize;
  return fileSize >= multipartMinFileSize;
};

const sliceChunk = (file, index, fileSize, chunkSize) => {
  const start = chunkSize * index;
  const end = Math.min(start + chunkSize, fileSize);
  return file.slice(start, end);
};

function prepareChunks(file, fileSize, chunkSize) {
  return index => sliceChunk(file, index, fileSize, chunkSize);
}

const runWithConcurrency = (concurrency, tasks) => {
  return new Promise((resolve, reject) => {
    const results = [];
    let rejected = false;
    let settled = tasks.length;
    const forRun = [...tasks];

    const run = () => {
      const index = tasks.length - forRun.length;
      const next = forRun.shift();

      if (next) {
        next().then(result => {
          if (rejected) return;
          results[index] = result;
          settled -= 1;

          if (settled) {
            run();
          } else {
            resolve(results);
          }
        }).catch(error => {
          rejected = true;
          reject(error);
        });
      }
    };

    for (let i = 0; i < concurrency; i++) {
      run();
    }
  });
};

const uploadPart = (chunk, url, _ref45) => {
  let publicKey = _ref45.publicKey,
      onProgress = _ref45.onProgress,
      signal = _ref45.signal,
      integration = _ref45.integration,
      retryThrottledRequestMaxTimes = _ref45.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref45.retryNetworkErrorMaxTimes;
  return multipartUpload(chunk, url, {
    publicKey,
    onProgress,
    signal,
    integration,
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes
  });
};

const uploadMultipart = (file, _ref46) => {
  let publicKey = _ref46.publicKey,
      fileName = _ref46.fileName,
      fileSize = _ref46.fileSize,
      baseURL = _ref46.baseURL,
      secureSignature = _ref46.secureSignature,
      secureExpire = _ref46.secureExpire,
      store = _ref46.store,
      signal = _ref46.signal,
      onProgress = _ref46.onProgress,
      source = _ref46.source,
      integration = _ref46.integration,
      userAgent = _ref46.userAgent,
      retryThrottledRequestMaxTimes = _ref46.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref46.retryNetworkErrorMaxTimes,
      contentType = _ref46.contentType,
      _ref46$multipartChunk = _ref46.multipartChunkSize,
      multipartChunkSize = _ref46$multipartChunk === void 0 ? defaultSettings.multipartChunkSize : _ref46$multipartChunk,
      _ref46$maxConcurrentR = _ref46.maxConcurrentRequests,
      maxConcurrentRequests = _ref46$maxConcurrentR === void 0 ? defaultSettings.maxConcurrentRequests : _ref46$maxConcurrentR,
      baseCDN = _ref46.baseCDN,
      metadata = _ref46.metadata;
  const size = fileSize || getFileSize(file);
  let progressValues;

  const createProgressHandler = (totalChunks, chunkIdx) => {
    if (!onProgress) return;

    if (!progressValues) {
      progressValues = Array(totalChunks).fill(0);
    }

    const sum = values => values.reduce((sum, next) => sum + next, 0);

    return info => {
      if (!info.isComputable) {
        return;
      }

      progressValues[chunkIdx] = info.value;
      onProgress({
        isComputable: true,
        value: sum(progressValues) / totalChunks
      });
    };
  };

  return multipartStart(size, {
    publicKey,
    contentType,
    fileName: fileName !== null && fileName !== void 0 ? fileName : file.name,
    baseURL,
    secureSignature,
    secureExpire,
    store,
    signal,
    source,
    integration,
    userAgent,
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes,
    metadata
  }).then(_ref47 => {
    let uuid = _ref47.uuid,
        parts = _ref47.parts;
    const getChunk = prepareChunks(file, size, multipartChunkSize);
    return Promise.all([uuid, runWithConcurrency(maxConcurrentRequests, parts.map((url, index) => () => uploadPart(getChunk(index), url, {
      publicKey,
      onProgress: createProgressHandler(parts.length, index),
      signal,
      integration,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes
    })))]);
  }).then(_ref48 => {
    let _ref49 = _slicedToArray(_ref48, 1),
        uuid = _ref49[0];

    return multipartComplete(uuid, {
      publicKey,
      baseURL,
      source,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes
    });
  }).then(fileInfo => {
    if (fileInfo.isReady) {
      return fileInfo;
    } else {
      return isReadyPoll({
        file: fileInfo.uuid,
        publicKey,
        baseURL,
        source,
        integration,
        userAgent,
        retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes,
        onProgress,
        signal
      });
    }
  }).then(fileInfo => new UploadcareFile(fileInfo, {
    baseCDN
  }));
};
/**
 * Uploads file from provided data.
 */


function uploadFile(data, _ref50) {
  let publicKey = _ref50.publicKey,
      fileName = _ref50.fileName,
      _ref50$baseURL = _ref50.baseURL,
      baseURL = _ref50$baseURL === void 0 ? defaultSettings.baseURL : _ref50$baseURL,
      secureSignature = _ref50.secureSignature,
      secureExpire = _ref50.secureExpire,
      store = _ref50.store,
      signal = _ref50.signal,
      onProgress = _ref50.onProgress,
      source = _ref50.source,
      integration = _ref50.integration,
      userAgent = _ref50.userAgent,
      retryThrottledRequestMaxTimes = _ref50.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref50.retryNetworkErrorMaxTimes,
      contentType = _ref50.contentType,
      multipartMinFileSize = _ref50.multipartMinFileSize,
      multipartChunkSize = _ref50.multipartChunkSize,
      maxConcurrentRequests = _ref50.maxConcurrentRequests,
      _ref50$baseCDN = _ref50.baseCDN,
      baseCDN = _ref50$baseCDN === void 0 ? defaultSettings.baseCDN : _ref50$baseCDN,
      checkForUrlDuplicates = _ref50.checkForUrlDuplicates,
      saveUrlForRecurrentUploads = _ref50.saveUrlForRecurrentUploads,
      pusherKey = _ref50.pusherKey,
      metadata = _ref50.metadata;

  if (isFileData(data)) {
    const fileSize = getFileSize(data);

    if (isMultipart(fileSize, multipartMinFileSize)) {
      return uploadMultipart(data, {
        publicKey,
        contentType,
        multipartChunkSize,
        fileName,
        baseURL,
        secureSignature,
        secureExpire,
        store,
        signal,
        onProgress,
        source,
        integration,
        userAgent,
        maxConcurrentRequests,
        retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes,
        baseCDN,
        metadata
      });
    }

    return uploadDirect(data, {
      publicKey,
      fileName,
      contentType,
      baseURL,
      secureSignature,
      secureExpire,
      store,
      signal,
      onProgress,
      source,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes,
      baseCDN,
      metadata
    });
  }

  if (isUrl(data)) {
    return uploadFromUrl(data, {
      publicKey,
      fileName,
      baseURL,
      baseCDN,
      checkForUrlDuplicates,
      saveUrlForRecurrentUploads,
      secureSignature,
      secureExpire,
      store,
      signal,
      onProgress,
      source,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes,
      pusherKey,
      metadata
    });
  }

  if (isUuid(data)) {
    return uploadFromUploaded(data, {
      publicKey,
      fileName,
      baseURL,
      signal,
      onProgress,
      source,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes,
      baseCDN
    });
  }

  throw new TypeError("File uploading from \"".concat(data, "\" is not supported"));
}

class UploadcareGroup {
  constructor(groupInfo, files) {
    this.storedAt = null;
    this.uuid = groupInfo.id;
    this.filesCount = groupInfo.filesCount;
    this.totalSize = Object.values(groupInfo.files).reduce((acc, file) => acc + file.size, 0);
    this.isStored = !!groupInfo.datetimeStored;
    this.isImage = !!Object.values(groupInfo.files).filter(file => file.isImage).length;
    this.cdnUrl = groupInfo.cdnUrl;
    this.files = files;
    this.createdAt = groupInfo.datetimeCreated;
    this.storedAt = groupInfo.datetimeStored;
  }

}
/**
 * FileData type guard.
 */


const isFileDataArray = data => {
  for (const item of data) {
    if (!isFileData(item)) {
      return false;
    }
  }

  return true;
};
/**
 * Uuid type guard.
 */


const isUuidArray = data => {
  for (const item of data) {
    if (!isUuid(item)) {
      return false;
    }
  }

  return true;
};
/**
 * Url type guard.
 */


const isUrlArray = data => {
  for (const item of data) {
    if (!isUrl(item)) {
      return false;
    }
  }

  return true;
};

function uploadFileGroup(data, _ref51) {
  let publicKey = _ref51.publicKey,
      fileName = _ref51.fileName,
      _ref51$baseURL = _ref51.baseURL,
      baseURL = _ref51$baseURL === void 0 ? defaultSettings.baseURL : _ref51$baseURL,
      secureSignature = _ref51.secureSignature,
      secureExpire = _ref51.secureExpire,
      store = _ref51.store,
      signal = _ref51.signal,
      onProgress = _ref51.onProgress,
      source = _ref51.source,
      integration = _ref51.integration,
      userAgent = _ref51.userAgent,
      retryThrottledRequestMaxTimes = _ref51.retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes = _ref51.retryNetworkErrorMaxTimes,
      contentType = _ref51.contentType,
      _ref51$multipartChunk = _ref51.multipartChunkSize,
      multipartChunkSize = _ref51$multipartChunk === void 0 ? defaultSettings.multipartChunkSize : _ref51$multipartChunk,
      _ref51$baseCDN = _ref51.baseCDN,
      baseCDN = _ref51$baseCDN === void 0 ? defaultSettings.baseCDN : _ref51$baseCDN,
      jsonpCallback = _ref51.jsonpCallback;

  if (!isFileDataArray(data) && !isUrlArray(data) && !isUuidArray(data)) {
    throw new TypeError("Group uploading from \"".concat(data, "\" is not supported"));
  }

  let progressValues;
  let isStillComputable = true;
  const filesCount = data.length;

  const createProgressHandler = (size, index) => {
    if (!onProgress) return;

    if (!progressValues) {
      progressValues = Array(size).fill(0);
    }

    const normalize = values => values.reduce((sum, next) => sum + next) / size;

    return info => {
      if (!info.isComputable || !isStillComputable) {
        isStillComputable = false;
        onProgress({
          isComputable: false
        });
        return;
      }

      progressValues[index] = info.value;
      onProgress({
        isComputable: true,
        value: normalize(progressValues)
      });
    };
  };

  return Promise.all(data.map((file, index) => uploadFile(file, {
    publicKey,
    fileName,
    baseURL,
    secureSignature,
    secureExpire,
    store,
    signal,
    onProgress: createProgressHandler(filesCount, index),
    source,
    integration,
    userAgent,
    retryThrottledRequestMaxTimes,
    retryNetworkErrorMaxTimes,
    contentType,
    multipartChunkSize,
    baseCDN
  }))).then(files => {
    const uuids = files.map(file => file.uuid);
    return group(uuids, {
      publicKey,
      baseURL,
      jsonpCallback,
      secureSignature,
      secureExpire,
      signal,
      source,
      integration,
      userAgent,
      retryThrottledRequestMaxTimes,
      retryNetworkErrorMaxTimes
    }).then(groupInfo => new UploadcareGroup(groupInfo, files)).then(group => {
      onProgress && onProgress({
        isComputable: true,
        value: 1
      });
      return group;
    });
  });
}
/**
 * Populate options with settings.
 */


const populateOptionsWithSettings = (options, settings) => _objectSpread(_objectSpread({}, settings), options);

class UploadClient {
  constructor(settings) {
    this.settings = Object.assign({}, defaultSettings, settings);
  }

  updateSettings(newSettings) {
    this.settings = Object.assign(this.settings, newSettings);
  }

  getSettings() {
    return this.settings;
  }

  base(file) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return base(file, populateOptionsWithSettings(options, settings));
  }

  info(uuid) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return info(uuid, populateOptionsWithSettings(options, settings));
  }

  fromUrl(sourceUrl) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return fromUrl(sourceUrl, populateOptionsWithSettings(options, settings));
  }

  fromUrlStatus(token) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return fromUrlStatus(token, populateOptionsWithSettings(options, settings));
  }

  group(uuids) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return group(uuids, populateOptionsWithSettings(options, settings));
  }

  groupInfo(id) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return groupInfo(id, populateOptionsWithSettings(options, settings));
  }

  multipartStart(size) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return multipartStart(size, populateOptionsWithSettings(options, settings));
  }

  multipartUpload(part, url) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const settings = this.getSettings();
    return multipartUpload(part, url, populateOptionsWithSettings(options, settings));
  }

  multipartComplete(uuid) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return multipartComplete(uuid, populateOptionsWithSettings(options, settings));
  }

  uploadFile(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return uploadFile(data, populateOptionsWithSettings(options, settings));
  }

  uploadFileGroup(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const settings = this.getSettings();
    return uploadFileGroup(data, populateOptionsWithSettings(options, settings));
  }

}

export { UploadClient, UploadClientError, UploadcareFile, UploadcareGroup, UploadcareNetworkError, base, fromUrl, fromUrlStatus, getUserAgent$1 as getUserAgent, group, groupInfo, info, multipartComplete, multipartStart, multipartUpload, uploadDirect, uploadFile, uploadFileGroup, uploadFromUploaded, uploadFromUrl, uploadMultipart };